
// if (typeof Object.assign != 'function') {
//   Object.assign = function(target) {
//     'use strict';
//     if (target == null) {
//       throw new TypeError('Cannot convert undefined or null to object');
//     }

//     target = Object(target);
//     for (var index = 1; index < arguments.length; index++) {
//       var source = arguments[index];
//       if (source != null) {
//         for (var key in source) {
//           if (Object.prototype.hasOwnProperty.call(source, key)) {
//             target[key] = source[key];
//           }
//         }
//       }
//     }
//     return target;
//   };
// }

// var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

// var isEdge = false;
// if (document.documentMode || /Edge/.test(navigator.userAgent) || /Edg/.test(navigator.userAgent)) {
//   isEdge = true;
// }

// var Promise = require('es6-promise').Promise;
// require('isomorphic-fetch');
// require('es6-shim');
// require('es6-promise/auto');
// import "@babel/polyfill";


// import Promise from 'promise-polyfill';






import Vue from 'vue';
// import Vuelidate from 'vuelidate';
import objectFitImages from 'object-fit-images';
import Components from "./components";
import Cookies from 'js-cookie';
import EventBus from './utils/event-bus';
import axios from 'axios';
import * as Scrll from './funcs.js';
import * as Cookie from './cookies.js';
import * as Bot from './isbot.js';
import 'picturefill';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

// Vue.use(Vuelidate);

new Vue({
  el: "#app",
  delimiters: ["${", "}"],
  data: {
    focusOn: false,
    stickyOn: false,
    navOn: false,
    navActive: [],
    subNavOn: false,
    subNavActive: [currentServiceGroupId],
    megaActive: [],
    geo: Cookies.get('bensonGeo'),
    allClinics: {},
    mapOn: false
  },
  methods: {

    focusActivate (e) {
      if (e.keyCode === 9 || e.keyCode === 13) {
        this.focusOn = true;
      }
    },

    focusDeactivate (e) {
      this.focusOn = false;
    },

    handleScroll (e) {
      var scrollY = window.scrollY;
      if (scrollY > 0) {
        this.stickyOn = true;
      } else {
        this.stickyOn = false;
      }
    },

    handleResize (e) {

    },

    navExpand(e, id, forceOpen) {
      if (this.navActive.includes(id)) {
        if (typeof forceOpen == 'undefined') {
          this.navActive.remove(id);
        }
      } else {
        this.navActive.push(id);
        // scrll.scrollToAnchor('nav' + id, $('.nav-nav'));
      }
      this.navOn = true;
      e.preventDefault();
      return false;
    },

    megaExpand(e, id) {
      if (this.megaActive.includes(id)) {
        this.megaActive.remove(id);
      } else {
        this.megaActive.push(id);
      }
      e.preventDefault();
      return false;
    },

    subNavExpand(e, id, forceOpen) {
      if (this.subNavActive.includes(id)) {
        if (typeof forceOpen == 'undefined') {
          this.subNavActive.remove(id);
        }
      } else {
        this.subNavActive.push(id);
      }
      e.preventDefault();
      return false;
    },

    async getCities() {
      try {
        const res = await axios.get('/js/cities.au.250822.min.json');
        const cities = res.data;
        EventBus.$emit('LOAD_CITIES', cities);
      } catch (e) {
        console.error(e);
      }
    },

  },
  created () {

    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

  },
  destroyed () {

    window.removeEventListener('scroll', this.handleScroll);

    window.removeEventListener('scroll', this.handleResize);

  },
  mounted () {

    this.getCities();

    if (typeof window.clinics !== 'undefined') {
      this.allClinics = window.clinics;
    }

    EventBus.$on('MAP_SHOW', (searchId) => {
      this.mapOn = true;
    });

    EventBus.$on('MAP_HIDE', (searchId) => {
      this.mapOn = false;
    });

  }
});


//* array remove =================================================== */

Array.prototype.remove = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};


//* objectfit polyfill =================================================== */

objectFitImages();


//* is touch device =================================================== */

var isTouch = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  isTouch = true;
}


//* bot check =================================================== */

var isBot = Bot.check();


//* breakpoints =================================================== */

function breakpointWidth(bp) {
  bpWidth = 768;
  if (bp == 'baby') {
    bpWidth = 479;
  }
  if (bp == 'teen') {
    bpWidth = 600;
  }
  if (bp == 'mama') {
    bpWidth = 768;
  }
  if (bp == 'mega') {
    bpWidth = 1279;
  }
  return bpWidth;
}

function breakpointMax(bp) {
  bpWidth = breakpointWidth(bp);
  if ($(window).width() <= bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}

function breakpointMin(bp) {
  bpWidth = breakpointWidth(bp);
  if ($(window).width() > bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}


//* scroll to anchor =================================================== */

// all hashtags
$(document).on('click','a[href^="#"]',function(){
  var $this = $(this);
  var aId = $this.attr('href').replace('#','');;
  var $anchorElement = $('[id="' + aId + '"], [name="' + aId + '"], [data-id="' + aId + '"]');
  if ($anchorElement.length > 0) {
    Scrll.scrollToAnchor(aId);
    return false;
  }
});

// scroll if hashtag
$(document).ready(function(){
  var hash = window.location.hash.replace('#', '');
  if (hash != '') {
    Scrll.scrollToAnchor(hash);
  }
});


//* accordion =================================================== */

$(document).on('click','.accordion-head',function(){
  var $accordion = $(this).parents('.accordion');
  var $panel = $accordion.find('.accordion-body');
  if ($accordion.hasClass('s_active')) {
    $('.accordion').removeClass('s_active');
    $panel[0].style.maxHeight = 0;
  } else {
    $('.accordion').removeClass('s_active');
    $accordion.addClass('s_active');
    $panel[0].style.maxHeight = $panel[0].scrollHeight + 'px';
  }
});


//* notices =================================================== */

function noticeInit() {
  if (!isBot) {
    $('.sitenotice').each(function(){
      var cookieName = $(this).attr('data-id');
      if (Cookie.read(cookieName)) {
      } else {
        $(this).addClass('s_active');
      }
    });
  }
}

noticeInit();

$(document).on('click','[data-action="notice-close"]',function(){
  var cookieName = $(this).parents('.sitenotice').attr('data-id');
  var cookieExpiresHours = $(this).parents('.sitenotice').attr('data-ex');
  var cookieExpiresDays = cookieExpiresHours / 24;
  Cookie.create(cookieName, 1, cookieExpiresDays); // 2 hours expiry
  var $this = $(this);
  $this.parents('.sitenotice').removeClass('s_active');
});


//* videos =================================================== */

var youtube = document.querySelectorAll(".video");

$(document).on('click','.video',function(){

  var videoId = $(this).attr('data-embed');

  if (videoId.length) {

    $(this).find('.video-play').remove();

    $(this).find('.video-overlay').html('').show();
    $('<iframe>', {
     src: 'https://www.youtube.com/embed/' + videoId + '?rel=0&showinfo=0&autoplay=1',
     id: 'myFrame',
     frameborder: 0,
     scrolling: 'no',
     allow: 'autoplay; encrypted-media;'
    }).appendTo($(this).find('.video-overlay'));

  } else {

    $(this).remove();

  }

});